<template>
  <div class="page">
    <PageHeader>Пользователь API обмена {{ apiUser.name }}</PageHeader>
    <div class="content">
      <el-card shadow="always" :body-style="{ padding: '20px' }">
        <div slot="header">
          <el-row :gutter="20">
            <el-col :span="10">
              <div>
                <el-statistic title="Всего QIWI получено">
                  <template slot="formatter">
                    <animated-number
                      :value="totalFrom"
                      :formatValue="formatToPrice(' RUB')"
                      :duration="500"
                    />
                  </template>
                </el-statistic>
              </div>
            </el-col>
            <el-col :span="4">
              <el-popover placement="bottom" width="400" trigger="click">
                <div>Суммировать статусы:</div>
                <el-checkbox-group v-model="totalStatuses">
                  <el-checkbox
                    v-for="status in Object.entries(statuses)"
                    :key="status[0]"
                    :label="+status[0]"
                    >{{ status[1].text }}</el-checkbox
                  >
                </el-checkbox-group>
                <el-button
                  slot="reference"
                  icon="el-icon-shopping-cart-2"
                  circle
                ></el-button>
              </el-popover>
            </el-col>
            <el-col :span="10">
              <div>
                <el-statistic title="Всего USDT отправлено">
                  <template slot="formatter">
                    <animated-number
                      :value="totalTo"
                      :formatValue="formatToPrice(' USDT')"
                      :duration="500"
                    />
                  </template>
                </el-statistic>
              </div>
            </el-col>
          </el-row>

          <!-- <el-divider
            direction="horizontal"
            content-position="left"
          ></el-divider> -->

          <el-collapse>
            <el-collapse-item name="1">
              <template slot="title">
                Фильтры
              </template>
              <el-row :gutter="20">
                <el-col :span="12" :offset="0">
                  <el-date-picker
                    v-model="filters.dateRange"
                    type="datetimerange"
                    align="right"
                    start-placeholder="От"
                    end-placeholder="До"
                    :default-time="['00:00:00', '23:59:59']"
                  >
                  </el-date-picker>
                </el-col>
                <el-col :span="12" :offset="0">
                  <el-input
                    v-model="filters.search"
                    placeholder="Поиск по ID"
                    size="normal"
                    clearable
                  ></el-input>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24" :offset="0">
                  <el-checkbox-group v-model="filters.statuses">
                    <el-checkbox
                      v-for="status in Object.entries(statuses)"
                      :key="status[0]"
                      :label="+status[0]"
                      >{{ status[1].text }}</el-checkbox
                    >
                  </el-checkbox-group>
                </el-col>
              </el-row>
            </el-collapse-item>
          </el-collapse>
        </div>
        <virtual-list
          style="height: 600px;overflow-y: auto;"
          :data-key="'_id'"
          :data-sources="filteredTransactions"
          :data-component="itemComponent"
        />
      </el-card>
    </div>
  </div>
</template>
<script>
import { queryTransactions, getApiUser } from "@/api";
import TransactionComponent from "./transaction.vue";
import VirtualList from "vue-virtual-scroll-list";
import AnimatedNumber from "animated-number-vue";
import statuses from "./statuses";
import PageHeader from "../../../ui/PageHeader.vue";

const apistatuses = Object.fromEntries(
  Object.entries(statuses).filter(st => !["default", "5", "6"].includes(st[0]))
);

const defaultFilters = {
  dateRange: null,
  search: "",
  statuses: Object.entries(apistatuses).map(status => +status[0])
};
export default {
  name: "ApiUserPage",
  components: { PageHeader, TransactionComponent, AnimatedNumber, VirtualList },
  data: () => ({
    loading: false,
    transactions: [],
    result: {},
    apiUser: {},
    itemComponent: TransactionComponent,
    interval: null,
    filters: {
      ...defaultFilters
    },
    statuses: apistatuses,
    totalStatuses: [2]
  }),
  computed: {
    filtersIsOn() {
      //does not works - arrays are always in different order
      return JSON.stringify(defaultFilters) !== JSON.stringify(this.filters);
    },
    filteredTransactions() {
      return this.transactions
        .sort((a, b) => {
          return new Date(b.date) - new Date(a.date);
        })
        .filter(tr => {
          const trDate = new Date(tr.date);
          if (
            this.filters.dateRange &&
            this.filters.dateRange[0] &&
            trDate < this.filters.dateRange[0]
          )
            return false;
          if (
            this.filters.dateRange &&
            this.filters.dateRange[1] &&
            trDate > this.filters.dateRange[1]
          )
            return false;
          if (!this.filters.statuses.includes(+tr.status)) return false;
          if (
            !!this.filters.search &&
            !tr._id.toLowerCase().includes(this.filters.search.toLowerCase())
          )
            return false;
          return true;
        });
    },
    totalFrom() {
      return this.filteredTransactions
        .filter(t => this.totalStatuses.includes(+t.status))
        .reduce((prev, curr) => {
          const amount = curr.giveValute.forms.find(f => f.key === "count");
          return prev + +amount.value;
        }, 0);
    },
    totalTo() {
      return this.filteredTransactions
        .filter(t => this.totalStatuses.includes(+t.status))
        .reduce((prev, curr) => {
          const amount = curr.getValute.forms.find(f => f.key === "result");
          return prev + +amount.value;
        }, 0);
    }
  },
  methods: {
    async loadTransactions() {
      this.loading = true;
      const res = await queryTransactions({
        query: { apiUser: this.apiUser._id },
        pagination: false
      });
      this.result = res.data.result;
      this.transactions = res.data.result.docs;
      this.loading = false;
    },
    async getApiUser() {
      if (this.$route.params["id"]) {
        this.loading = true;
        const res = await getApiUser(this.$route.params["id"]);
        this.apiUser = res.data.result;
        this.loading = false;
      }
    },
    formatToPrice(suffix = "") {
      return value => {
        const formatter = new Intl.NumberFormat("ru-ru", {
          style: "decimal",
          useGrouping: true,
          maximumFractionDigits: 2,
          minimumFractionDigits: 2
        });
        // return `${value.toFixed(2)}${suffix}`
        return `${formatter.format(value)}${suffix}`;
      };
    }
  },
  async mounted() {
    await this.getApiUser();
    await this.loadTransactions();
    this.interval = setInterval(async () => {
      await this.loadTransactions();
    }, 60000);
  },
  beforeDestroy() {
    if (this.interval) clearInterval(this.interval);
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/pages/ApiUsers/Stats/index.vue